import { useEffect, useState } from "react";
import { api, OPC } from "@/lib/api";
import { DataList } from "@/components/Fields";

export const RemitentesList = ({ id }) => {
  const [opts, setOpts] = useState(OPC.quien_remite);
  useEffect(() => {
    api.get("/patients/remitentes").then((r) => setOpts([...new Set([...OPC.quien_remite, ...r.data])]));
  }, []);
  return <DataList id={id} options={opts} />;
};
